/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql, Link } from "gatsby"

import Header from "./header"
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/custom.css'

import { Container } from "react-bootstrap"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      <main>{children}</main>
      <footer>
        <Container className="singleCol pt-3 text-center">
          <p className="small">
          © {new Date().getFullYear()}, IDSS | Website Design by <a href="https://nautilusdesigns.com">Nautilus Designs</a>
          <br />
          Connect with me on <a href="https://www.facebook.com/julia.a.myers">Facebook</a>, <a href="https://www.linkedin.com/in/juliamyers01/">LinkedIn</a> & <a href="https://www.instagram.com/idss.llc/">Instagram</a>
          <br />
          <Link to="/disclaimer/">Disclaimer</Link>
          </p>
        </Container>
      </footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
